import { ReactElement, CSSProperties, useRef, useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useFetchDesignSchemeMutation } from '../../redux/services/calculations';
import { LoadType, SpansAndLoads } from '../../types/domainTypes';
import { CalculationContext } from '../../pages/Calculation/CalculationContextProvider';

interface Props {
  spansAndLoads: SpansAndLoads;
  loadType: LoadType;
  style?: CSSProperties;
}

export function DesignSchemeView({ spansAndLoads, loadType, style }: Props): ReactElement {
  const { t } = useTranslation();
  const { product } = useContext(CalculationContext);
  const [updateDesignSchemeImage, designSchemeImage] = useFetchDesignSchemeMutation();
  const objectUrl = useRef('');
  const [designSchemeObject, setDesignSchemeObject] = useState('');

  useEffect(() => {
    if (loadType === 'PermanentLoad') {
      const newSpansAndLoads = {
        ...spansAndLoads,
        permanentLoads: {
          ...spansAndLoads.permanentLoads,
          selfWeight: product?.selfWeight,
        },
      };

      updateDesignSchemeImage({
        spansAndLoads: { ...newSpansAndLoads },
        loadType,
      });
    } else {
      updateDesignSchemeImage({ spansAndLoads, loadType });
    }
  }, [updateDesignSchemeImage, spansAndLoads, loadType, product?.selfWeight]);

  useEffect(() => {
    if (designSchemeImage.data) {
      if (objectUrl.current) {
        URL.revokeObjectURL(objectUrl.current);
      }
      objectUrl.current = URL.createObjectURL(new Blob([designSchemeImage.data], { type: 'image/svg+xml' }));
      setDesignSchemeObject(objectUrl.current);
    }
  }, [designSchemeImage.data]);

  if (!designSchemeObject) {
    return <div data-testid="designScheme" style={{ height: '331px' }} />;
  }

  return <img data-testid="designScheme" src={designSchemeObject} alt={t('calculation-page.design-scheme-alt-text')} style={style} />;
}
